import { MASKABLE_FIELD_MINIMIZED_CLASS } from "@/lib/maskable-field-styles";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

type MaskableFieldTrailingProps = {
  minimized?: boolean;
  children: ReactNode;
  className?: string;
};

/** Corner content (e.g. publication switch) shown beside a maskable text field header. */
export function MaskableFieldTrailing({
  minimized,
  children,
  className,
}: MaskableFieldTrailingProps) {
  return (
    <div
      className={cn(
        "flex items-center",
        minimized &&
          cn(
            "pointer-events-none select-none",
            MASKABLE_FIELD_MINIMIZED_CLASS,
            "[&_label]:text-muted-foreground",
          ),
        className,
      )}
      aria-hidden={minimized ? true : undefined}
    >
      {children}
    </div>
  );
}
